export const getDefaultShowOrHideString = (value: string, isAddingClauseVariations: boolean) => {
    if (isAddingClauseVariations) {
        if (value !== 'show' && value !== 'hide') {
            return { value: value.split('-')[1], label: value.split('-')[1] };
        }
    }

    return { label: value, value };
};
